import * as React from 'react';
import { PageRoutes } from '../root/Routes';
import './authentication.css';
import { AuthenticationFooter } from '../common/authenticationCardComponents/AuthenticationFooter';
import { CardHeader } from '../common/authenticationCardComponents/CardHeader';
import { LucidLinkLogo } from '../common/Icons';
import { DONT_HAVE_AN_ACCOUNT_YET_MESSAGE, LUCIDLINK_WEBSITE, SIGN_UP_MESSAGE } from '../../utils/constants';

class ResetPasswordCodeExpired extends React.Component <any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
        <div className="auth">
          <div className="auth_wrapper">
            <header>
                <a href={LUCIDLINK_WEBSITE}>
                    <LucidLinkLogo width={'130px'} height={'50px'}/>
                </a>
            </header>
            <div className="auth_block">
              <div>
                <CardHeader message={'Expired verification code'}/>
                <div className="center">
                  <p className="red mb-0">Your verification code has expired</p>
                  <p>Click below to return to the sign-in page</p>
                </div>
                <button
                    id="sign_up"
                    className="btn"
                    onClick={this.redirectToSignIn}
                >
                    Return to Sign in
                </button>
              </div>
            </div>
            <AuthenticationFooter message={{ text: DONT_HAVE_AN_ACCOUNT_YET_MESSAGE, label: SIGN_UP_MESSAGE }}/>
          </div>
        </div>
    );
  }

  redirectToSignIn = () => {
    this.props.history.push(PageRoutes.Login);
  }
}

export default ResetPasswordCodeExpired;



// WEBPACK FOOTER //
// ./src/webportal/components/authentication/ResetPasswordCodeExpired.tsx